<template>
  <div class="dadosFalecimBox">
    <h2 class="dadosFalecimBox_header"
        :class="{'dadosFalecimBox_header_error': propCorrecoes['LOCAL DE OCORRÊNCIA'] }">
      Ocorrência do óbito
      <span v-if="propCorrecoes['LOCAL DE OCORRÊNCIA']">
        <IconSvg class="icon-error-campo"
                 icon="alert" />
        Há campos incorretos
      </span>
    </h2>
    <form class="px-2 pt-2"
          name="formOcorrenciaObito"
          novalidate
          @submit.prevent="() => ({})">
      <div class="row align-items-end">
        <div v-if="!propLegado"
             class="col-sm-4 col-lg-3">
          <div class="form-group">
            <label class="label"
                   for="numero_declaracao_obito">Nº Declaração de Óbito</label>
            <input id="numero_declaracao_obito"
                   ref="falecido_numero_declaracao_obito"
                   v-model="localData.numero_declaracao_obito"
                   v-validate:numDO="{ min: 9 }"
                   v-mask="{ mask: '99999999[-9]', greedy: false }"
                   :class="{ 'is-invalid': errors.has('numero_declaracao_obito') }"
                   class="form-control form-control-sm"
                   name="numero_declaracao_obito"
                   placeholder="00000000-0"
                   maxlength="15"
                   minlength="9"
                   type="tel"
                   :disabled="disable_numero_declaracao_obito"
                   @change="[checkDeclaracaoObito(), validateInputs('numero_declaracao_obito')]">
            <small v-if="errors.has('numero_declaracao_obito')"
                   class="invalid-feedback">{{ errors.first('numero_declaracao_obito') }}</small>
          </div>
        </div>

        <div v-if="!propLegado"
             class="col">
          <div class="form-group">
            <span class="custom-control custom-switch mr-4">
              <input id="sem_do"
                     v-model="localData.sem_declaracao_obito"
                     class="custom-control-input"
                     name="sem_do"
                     type="checkbox"
                     @change="disableDeclaracao"
                     @keydown.enter="disableButton"
                     @keyup.enter="changeSemDeclaracao">
              <label class="custom-control-label"
                     for="sem_do">Não apresentou Declaração de Óbito</label>
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 col-lg-3">
          <div class="form-group">
            <label class="label"
                   for="data_ocorrido">Data de Falecimento</label>
            <input id="data_ocorrido"
                   v-model="localData.registro.data_ocorrido"
                   v-validate="`date_format:yyyy-MM-dd|date_between:${ initDate },${ limitDate }`"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.has('data_ocorrido') }"
                   name="data_ocorrido"
                   placeholder="00/00/0000"
                   type="date"
                   @change="updateDateRegistro">
            <small
              v-if="errors.has('data_ocorrido')"
              class="invalid-feedback">{{ errors.first('data_ocorrido') }}</small>
          </div>
        </div>

        <div class="col-sm-4 col-lg-3">
          <div class="form-group">
            <label class="label"
                   for="hora_ocorrido">Hora de Falecimento</label>
            <input id="hora_ocorrido"
                   v-model="localData.registro.hora_ocorrido"
                   v-mask="`##:##`"
                   v-validate="'date_format:HH:mm'"
                   :class="{ 'is-invalid': errors.has('hora_ocorrido') }"
                   class="form-control form-control-sm"
                   name="hora_ocorrido"
                   placeholder="00:00"
                   type="tel"
                   @change="updateRegistroField">
            <small v-if="errors.has('hora_ocorrido')"
                   class="invalid-feedback">{{ errors.first('hora_ocorrido') && `Hora Inválida` }}</small>
          </div>
        </div>

        <div v-if="localData.natimorto"
             class="col-sm-5 col-lg-4">
          <div class="form-group">
            <label class="label"
                   for="semanas_gestacao">Nº de semanas de duração da gestação</label>
            <div class="col-12 m-0 p-0 d-inline-flex justify-content-between">
              <div class="col-4 m-0 p-0">
                <input id="semanas_gestacao"
                       v-model="localData.semanas_gestacao"
                       :class="{ 'is-invalid': errors.has('semanas_gestacao') }"
                       class="form-control form-control-sm"
                       name="semanas_gestacao"
                       placeholder="00"
                       type="number"
                       max="55"
                       :disabled="localData.semanas_gestacao_ignorada"
                       @change="changed()">
                <small v-if="errors.has('semanas_gestacao')"
                       class="invalid-feedback">{{ errors.first('semanas_gestacao') }}</small>
              </div>

              <div class="col">
                <div class="form-group">
                  <span class="custom-control custom-switch mr-4">
                    <input id="semanas_gestacao_ignorado"
                           v-model="localData.semanas_gestacao_ignorada"
                           class="custom-control-input"
                           name="semanas_gestacao_ignorado"
                           type="checkbox"
                           @change="disableSemanasGestacao"
                           @keyup.enter="changeSemanaGestacao">
                    <label class="custom-control-label"
                           for="semanas_gestacao_ignorado">Ignorado</label>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LocalOcorrencia :local-ocorrencia="localData.registro.local"
                       :endereco-falecido="checkEnderecoFalecido()"
                       :prop-cartorio="propCartorio"
                       :read-only="true"
                       :prop-validator="propValidator"
                       :prop-correcoes="propCorrecoes"
                       @deleteError="deleteError"
                       @changed="getLocalOcorrencia" />
    </form>
    <GemeosObito v-if="localData.natimorto"
                 :data="localData.qtd_gemeos"
                 @addGemeo="addGemeo" />

    <CausaObito :data="localData.causaObito ? localData.causaObito : localData"
                :prop-correcoes="propCorrecoes"
                :prop-natimorto="data.natimorto"
                @deleteError="deleteError"
                @changed="getCausaObito" />

    <Medicos :lista-medicos="localData.medicos"
             :read-only="true"
             :prop-correcoes="propCorrecoes"
             @deleteError="deleteError"
             @medicoUpdated="medicoUpdated"
             @medicoRemoved="removeMedico" />

    <!--<LocalSepultamento :read-only="true"
                       :sepultamento="localData.sepultamento"
                       :disable-endereco="!!localData.sepultamento"
                       :sepultamento-id="localData.sepultamento_id"
                       :obito-id="Number(localData.obito_id)"
                       :prop-cartorio="propCartorio"
                       @onRemoveSepultamento="removeSepultamento"
                       @changed="getLocalSepultamento" />-->

    <Sepultamento
      :prop-sepultamento="localData.sepultamento"
      :prop-sepultamento-id="localData.sepultamento_id"
      :prop-sepultamento-certidao="localData.sepultamento_certidao"
      :prop-cartorio="propCartorio"
      @changed="getLocalSepultamento"
      @onRemoveSepultamento="removeSepultamento" />

    <Funeraria v-if="!propLegado"
               :convenio-funeraria="!!localData.funeraria"
               :prop-cartorio="propCartorio"
               :disable-endereco="!!localData.showEndereco"
               :funeraria-id="localData.funeraria_id"
               :funeraria="localData.funeraria || {}"
               :numero-declaracao-funeraria="localData.numero_declaracao_funeraria"
               :read-only="readOnly"
               @changed="updateFuneraria" />
  </div>
</template>

<script>
  /* components */
  import Funeraria from './Sessoes/Funeraria'
  import LocalOcorrencia from './Sessoes/LocalOcorrencia'
  import Sepultamento from './Sessoes/Sepultamento'
  import Medicos from './Sessoes/Medicos.vue'
  import CausaObito from './Sessoes/CausaObito'
  import GemeosObito from './Sessoes/GemeosObito'

  /* services */
  import RegistrosService from "@/services/Registros"
  import ObitoService from "@/services/Registros/Obito"
  import ValidateDeclarationService from "@/services/Registros/ValidateDeclarationService"

  /* filters */
  import { filterMaskedNumber } from '@/filters/filters'

  /* others */
  import moment from "moment"
  import Swal from "sweetalert2"

  export default {
    name: 'PassoDadosFalecimento',
    components: { Medicos, LocalOcorrencia, CausaObito, Sepultamento, Funeraria, GemeosObito },
    inject: ['$validator'],
    props: {
      data: { type: Object, default: () => {} },
      readOnly: { type: Boolean, default: () => false },
      propValidator: { type: Boolean, default: () => false },
      propCartorio: { type: Object, default: () => { return {} } },
      propCorrecoes: {type: Object, default: () => ({})},
      propLegado: {type: Boolean, default: false}
    },
    data () {
      return {
        deleteds: { medicos: [] },
        disable_numero_declaracao_obito: false,
        num_do: '',
        localData: {
          medicos: [],
          registro: {
            data_ocorrido: '',
            hora_ocorrido: '',
          },
          causaObito: {
            tipo_morte: '',
          },
          numero_declaracao_obito: null,
          sem_declaracao_obito: false,
          semanas_gestacao: null,
          semanas_gestacao_ignorada: false,
          qtd_gemeos: null
        },
        selectsOptions: {
          causasMorte: [],
          funerarias: []
        },
        initDate: moment('1500-01-01').format('YYYY-MM-DD'),
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD')
      }
    },
    computed: {
      numDO () {
        let value = this.localData.numero_declaracao_obito

        return filterMaskedNumber(value)
      }
    },
    watch: {
      data () {
        this.localData = {
          ...this.data,
        }

        if (this.localData.sem_declaracao_obito) {
          this.disable_numero_declaracao_obito = true
        }

        if (this.localData.semanas_gestacao === 0) {
          this.localData.semanas_gestacao_ignorada = true
        }

        this.checkEnderecoFalecido()
      }
    },
    created () {
      this.localData = this.data

      if (this.localData.sem_declaracao_obito) this.disable_numero_declaracao_obito = true

      if (this.localData.semanas_gestacao === 0) this.localData.semanas_gestacao_ignorada = true
    },
    mounted () {
      if (!this.propLegado) {
        this.$refs["falecido_numero_declaracao_obito"].focus()
      }

      this.init()
    },
    methods: {
      init () {
        if (!!this.data.data_nascimento) {
          this.initDate = moment(this.data.data_nascimento, 'DD/MM/YYYY').add(-1, 'days').format('YYYY-MM-DD')
        }
      },
      async updateDateRegistro () {
        if (this.localData.registro.data_ocorrido === '') {
          this.localData.registro.data_ocorrido = null
        }
        if (!this.readOnly) {
          await RegistrosService.updateRegistro(this.data.registro_id, { data_ocorrido: this.localData.registro.data_ocorrido })
        }
        this.changed()
      },

      async updateRegistroField (event) {
        let data = {[event.target.name]: event.target.value }
        if (this.localData.registro.hora_ocorrido === '') {
          this.localData.registro.hora_ocorrido = null
        }
        if (data.hora_ocorrido === '') {
          data.hora_ocorrido = null
        }

        if (!this.readOnly) {
          const updated = await RegistrosService.updateRegistro(this.data.registro_id, data)
        }
        this.changed()
      },
      async updateObitoField (event) {
        let data = {[event.target.name]: event.target.value }

        if (!this.readOnly) {
          const updated = await ObitoService.updateObito(this.$route.params.id, data, 0)
        }
        this.changed()
      },
      getLocalOcorrencia (localOcorrencia) {
        if (!Object.entries(localOcorrencia.localOcorrencia).length) {
          this.localData.registro.local_ocorrencia_id = null
        }

        this.localData.registro.localOcorrencia = localOcorrencia.localOcorrencia
        this.localData.registro.local = localOcorrencia.localOcorrencia

        this.changed()
      },
      async getCausaObito (causaObito) {
        this.localData = { ...this.localData, ...causaObito, causaObito: { ...causaObito } }

        if (!this.readOnly) {
          const updated = await ObitoService.updateObito(this.$route.params.id, causaObito, 0)
        }

        this.changed()
      },
      getLocalSepultamento (sepultamento) {
        // passando sepultamento_certidao para local original e excluindo de objeto
        this.localData.sepultamento_certidao = sepultamento.sepultamento_certidao

        this.localData.sepultamento_id = !!sepultamento.sepultamento_id ? sepultamento.sepultamento_id : null
        this.localData.sepultamento = sepultamento

        this.$emit('changed', this.localData)
      },
      removeSepultamento () {
        this.localData.sepultamento = null
        this.localData.sepultamento_id = null
        this.localData.sepultamento_certidao = null
        this.$emit('changed', this.localData)
      },
      updateFuneraria (objUpdate) {
        this.localData.numero_declaracao_funeraria = objUpdate.numero_declaracao_funeraria
        this.localData.showEndereco = objUpdate.showEndereco
        this.localData.funeraria_id = objUpdate.funeraria_id
        this.localData.funeraria = objUpdate.funeraria
        this.localData.convenio_funeraria = objUpdate.convenio_funeraria

        this.changed()
      },
      disableDeclaracao () {
        this.disable_numero_declaracao_obito = !this.disable_numero_declaracao_obito
        this.localData.numero_declaracao_obito = null
        this.changed()
      },
      addGemeo (val) {
        if (val.qtd_gemeos >= 2 ) {
          this.localData.qtd_gemeos = val.qtd_gemeos
        }
        else {
          this.localData.qtd_gemeos = '1'
        }

        this.changed()
      },
      removeMedico (medico) {
        this.localData.medicos = this.localData.medicos.filter((med) => med.crm !== medico.crm )
        this.$emit("medicoRemoved", medico)
        this.changed()
      },
      medicoUpdated (medico, localId) {
        this.localData.medicos[localId] = medico
        this.changed()
      },
      changed () {
        this.$emit('changed', this.localData)
      },
      validateInputs (name) {
        this.$validator.validate(name)
        this.changed()
      },
      async checkDeclaracaoObito () {
        const DO = this.localData.numero_declaracao_obito ? this.localData.numero_declaracao_obito.replace(/[-]/ig, '') : ''

        if (DO.length < 9) return

        try {
          await ValidateDeclarationService.validateDo(DO)
          this.localData.numero_declaracao_obito = DO
        } catch (e) {
          if (DO === this.data.numero_declaracao_obito) {
            this.localData.numero_declaracao_obito = DO
            return
          }

          objSwal.error.title = ''
          objSwal.error.text = e.response.data && e.response.data.message ? e.response.data.message : `D.O Número ${DO} não é válida`
          objSwal.error.html = ''

          this.localData.numero_declaracao_obito = null

          Swal.fire(objSwal.error)
        } finally {
          this.changed()
        }
      },
      checkEnderecoFalecido () {
        const { pessoa, enderecos } = this.localData

        //pega o endereco do registrado ao cadastrar registro
        if (enderecos && enderecos.length) return this.localData.enderecos[0]

        //pega o endereco do registrado ao editar registro
        else if (pessoa && pessoa.enderecos && pessoa.enderecos.length) return this.localData.pessoa.enderecos[0]

        else return {}
      },
      deleteError (error) {
        this.$emit('deleteError', error)
      },
      changeSemDeclaracao () {
        this.localData.sem_declaracao_obito = !this.localData.sem_declaracao_obito

        this.disableDeclaracao()
      },
      disableButton () {
        const btn = document.querySelector('.btn-add-local')

        if (btn) {
          btn.setAttribute('disabled', true)

          setTimeout(() => {
            btn.removeAttribute('disabled')
          })
        }
      },
      disableSemanasGestacao () {
        if (!!this.localData.semanas_gestacao_ignorada) this.localData.semanas_gestacao = 0
        else this.localData.semanas_gestacao = null

        this.changed()
      },
      changeSemanasGestacao () {
        this.localData.semanas_gestacao_ignorada = !this.localData.semanas_gestacao_ignorada

        this.disableSemanasGestacao()
      },
    },
  }
</script>

<style lang="scss">
  @import '../../../../scss/_utilities/exports';

  .dadosFalecimBox {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_error {
        color: #8B0000;
      }
    }
  }

  .iconAddLocal {
    width: 1rem;
    height: 1rem;
    fill: #1c7af5;
    margin-bottom: 0.2rem;
    margin-right: 0.2rem;
  }

  .btnAddLocal {
    background-color: white;
    color: #1c7af5;
    border-color: #1c7af5;
    margin-bottom: 1rem;
  }

  .btnAddLocal:hover {
    color: #1c7af5;
  }

</style>
